export * from './M100RichText';
export { M100RichText as default } from './M100RichText';
